import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useLang } from "@/lib/lang";
import LangDropdown from "@/components/site/LangDropdown";
import ClientKebabMenu from "@/components/site/ClientKebabMenu";

/**
 * Landing page top navigation. Offsets `top` when a partner ribbon is present.
 */
export default function LandingHeader({ partnerCtx, onBook, onScrollTo }) {
  const { user } = useAuth();
  const { t } = useLang();
  const isClient = user?.role === "client";

  return (
    <header className="dt-header" style={partnerCtx ? { top: 32 } : {}}>
      <div className="dt-header__inner">
        <a href="#top" className="dt-header__logo" data-testid="landing-logo">
          DI<span className="g">TOURS</span>
        </a>
        <nav className="dt-header__nav" data-testid="landing-nav">
          <button type="button" onClick={() => onScrollTo("tours")} data-testid="nav-tours">{t("landing_nav_tours")}</button>
          <button type="button" onClick={() => onScrollTo("transfers")} data-testid="nav-transfers">{t("landing_nav_transfers")}</button>
          <button type="button" onClick={() => onScrollTo("how")} data-testid="nav-how">{t("landing_nav_how")}</button>
          <button type="button" onClick={() => onScrollTo("join")} data-testid="nav-join">{t("landing_nav_join")}</button>
        </nav>
        <div className="dt-header__actions">
          <LangDropdown testId="landing-lang" />
          {isClient ? (
            <ClientKebabMenu userName={user.name} />
          ) : (
            <Link to="/login" className="dt-header__login" data-testid="header-login-btn">
              {t("landing_header_login")}
            </Link>
          )}
          <button
            type="button"
            className="dt-header__cta"
            onClick={() => onBook("executive")}
            data-testid="header-book-btn"
          >
            {t("landing_header_book")}
          </button>
        </div>
      </div>
    </header>
  );
}
